// Third-party libraries
import React from "react";
import Typography from "@mui/material/Typography";

// Local modules
import Shape from "../../shapes/Shape.jsx";

export default function ShapeFilter({ state = {}, dispatch }) {
  const { filters = [], searchQuery = {} } = state;
  const safeFilters = Array.isArray(filters) ? filters : [];
  const fields = Array.isArray(searchQuery.fields) ? searchQuery.fields : [];
  const shapeFilter = safeFilters.find((filter) => filter.name === "Shape");

  function isActive(shapeName) {
    const selectedField = fields.find((field) => field.name === "Shape");
    if (!selectedField || !Array.isArray(selectedField.values)) {
      return false;
    }

    return selectedField.values.some((value) => value.name === shapeName);
  }

  function selectShape(shapeName) {
    let updatedFields = fields.map((field) => ({
      ...field,
      values: Array.isArray(field.values) ? [...field.values] : [],
    }));

    const shapeFieldIndex = updatedFields.findIndex(
      (field) => field.name === "Shape"
    );
    const shapeField =
      shapeFieldIndex > -1 ? { ...updatedFields[shapeFieldIndex] } : null;

    if (shapeField) {
      if (!Array.isArray(shapeField.values)) {
        shapeField.values = [];
      }

      const isShapeSelected = shapeField.values.some(
        (value) => value.name === shapeName
      );

      if (isShapeSelected) {
        shapeField.values = shapeField.values.filter(
          (value) => value.name !== shapeName
        );

        if (shapeField.values.length === 0) {
          updatedFields = updatedFields.filter(
            (field) => field.name !== "Shape"
          );
        } else {
          updatedFields[shapeFieldIndex] = shapeField;
        }
      } else {
        shapeField.values = [...shapeField.values, { name: shapeName }];
        updatedFields[shapeFieldIndex] = shapeField;
      }
    } else {
      updatedFields.push({
        name: "Shape",
        values: [{ name: shapeName }],
      });
    }

    dispatch({ type: "updateSearchQuery", payload: updatedFields });
  }

  const shapeValues = Array.isArray(shapeFilter?.values)
    ? shapeFilter.values
    : [];

  return (
    <div className="filter filter--shape">
      {shapeValues.map((value) => (
        <div
          key={value.name}
          onClick={() => selectShape(value.name)}
          className="shape-value"
        >
          <div className="shape-icon pointer">
            <Shape
              type={value.name}
              color={isActive(value.name) ? "black" : "#4280aa"}
              stroke_width={isActive(value.name) ? "1%" : "0.4%"}
              width="40"
            />
          </div>
          <Typography
            variant="body3"
            className={[
              "pointer",
              "shape-label " +
                (isActive(value.name) ? "shape-label--selected" : ""),
            ].join(" ")}
          >
            {value.name}
          </Typography>
        </div>
      ))}
    </div>
  );
}
